import React from 'react';

import { connect } from 'react-redux';

import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';
import _ from 'lodash';
import {
  COST_OF_LIVING,
  FORM_NAME,
  EVENT_TYPE,
} from '../../../../../lib/analytics-constants';
import {
  inputOnChange,
  CostOfLivingInput,
  inputOnBlur,
} from '../../../../../lib/utils';
import { debouncedTrackInputEvent } from '../../../../../lib/analytics/trackers';
import useAnalytics from '../../../../../lib/analytics/use-analytics';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const HouseholdIncomeInput = ({
  inputs,
  label = '',
  fullWidth = true,
  value,
  errorMessage,
  dispatch,
}: CostOfLivingInput): JSX.Element => {
  const segmentAbstract = useAnalytics();
  const placeholder = num.formatCurrency(inputs?.income);
  const error = Boolean(errorMessage);

  const handleOnChange = (e: OnChangeEvent) => {
    // segment analytics
    debouncedTrackInputEvent(
      {
        entityName: 'pre-tax_household_annual_income',
        field: 'Pre-Tax Household Income',
        field_type: 'user_type_input',
        field_value: e.target.value,
      },
      segmentAbstract
    );

    inputOnChange({
      event: e,
      dispatch,
      fieldName: 'income',
      calculator: COST_OF_LIVING,
      inputType: 'currency',
    });
  };

  const numericValue = _.isNumber(value) ? Math.floor(Number(value)) : null;

  return (
    <InputMoney
      label={label}
      value={numericValue}
      placeholder={placeholder}
      error={error}
      errorMessage={errorMessage}
      onBlur={(e: OnChangeEvent) => {
        const bedrock = {
          eventType: EVENT_TYPE.INCOME_PRETAX_INCOME_UPDATED,
          was_prefilled: true,
          form_name: FORM_NAME.COST_OF_LIVING,
          valueFieldName: 'value_i',
          page_number: null,
          total_pages: null,
        };
        inputOnBlur({
          event: e,
          dispatch,
          // @ts-ignore error: not assignable to type '"value_i" | "value_n" | "value_s" | "value_ts"'
          bedrock,
          fieldName: 'income',
          calculator: COST_OF_LIVING,
          inputType: 'currency',
        });
      }}
      fullWidth={fullWidth}
      onChange={handleOnChange}
    />
  );
};

const mapStateToProps = (state) => ({
  value: state?.costOfLivingCalculator?.inputs?.income,
  errorMessage: state?.validations?.income?.[0],
});

export default connect(mapStateToProps)(HouseholdIncomeInput);
